require("@rails/ujs").start()
require("channels")

const images = require.context('../images', true)
const imagePath = (name) => images(name, true)

require("src")

import '../stylesheets/konintodoke.scss'
